import featureFlags from 'src/utils/featureFlag/feature-flags';

const FEATURES_FLAGS = {
  ...featureFlags,
};

export default FEATURES_FLAGS;
